import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
    return (
        <div style={styles.body}>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.inner}>

                        <div style={styles.logoContainer}>
                            <img
                                src="https://elasticbeanstalk-us-east-1-471112650330.s3.us-east-1.amazonaws.com/MockService3-dev/logo-orange.png"
                                alt="Zakhaa"
                                style={styles.logo}
                            />
                        </div>

                        <h1 style={styles.h1}>Zakhaa Contract Portal</h1>

                        <p style={styles.p}>
                            Select a document below to open and review the agreement.
                        </p>

                        <div style={styles.links}>

                            <Link style={styles.link} to="/official">
                                POS Device Sale or Lease Contract
                                <span style={styles.arrow}>→</span>
                            </Link>

                            <Link style={styles.link} to="/promo">
                                Promotional POS Device Sale or Lease Contract
                                <span style={styles.arrow}>→</span>
                            </Link>

                            <Link style={styles.link} to="/promo-002">
                                Promotional POS Device Sale or Lease Contract V2
                                <span style={styles.arrow}>→</span>
                            </Link>

                            <Link style={styles.link} to="/ed-agreement">
                                Economic Development Agreement
                                <span style={styles.arrow}>→</span>
                            </Link>

                        </div>

                        <div style={styles.divider}></div>

                        <p style={styles.p}>
                            If you require assistance regarding any agreement, please contact
                            our support team.
                        </p>

                        <p style={styles.support}>
                            <strong>Zakhaa Support Team</strong>
                            <br />
                            <a href="mailto:support@zakhaa.com" style={styles.email}>
                                support@zakhaa.com
                            </a>
                        </p>

                    </div>
                </div>

                <div style={styles.footer}>
                    © {new Date().getFullYear()} Zakhaa — All rights reserved.
                </div>
            </div>
        </div>
    );
}

const styles = {
    body: {
        margin: 0,
        padding: 0,
        minHeight: "100vh",
        background: "linear-gradient(180deg,#f8f9fd,#eef1f7)",
        fontFamily:
            "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
        color: "#111827",
    },

    container: {
        maxWidth: 640,
        margin: "0 auto",
        padding: 30,
    },

    card: {
        background: "#ffffff",
        borderRadius: 16,
        boxShadow: "0 10px 25px rgba(17,24,39,.08)",
        overflow: "hidden",
    },

    inner: {
        padding: 30,
    },

    logoContainer: {
        textAlign: "center",
        marginBottom: 10,
    },

    logo: {
        width: 110,
        height: "auto",
        objectFit: "contain",
    },

    h1: {
        fontSize: 22,
        fontWeight: 700,
        marginBottom: 10,
        textAlign: "center",
    },

    p: {
        fontSize: 14,
        lineHeight: 1.7,
        color: "#374151",
        textAlign: "center",
    },

    links: {
        marginTop: 25,
        display: "flex",
        flexDirection: "column",
        gap: 12,
    },

    link: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#f6f7fb",
        borderRadius: 10,
        padding: "14px 16px",
        textDecoration: "none",
        color: "#111827",
        fontSize: 14,
        fontWeight: 500,
        transition: "all .15s ease",
        border: "1px solid transparent",
    },

    arrow: {
        color: "#F9683D",
        fontWeight: 700,
    },

    divider: {
        height: 1,
        background: "#eef0f6",
        margin: "25px 0",
    },

    support: {
        textAlign: "center",
        fontSize: 14,
        lineHeight: 1.6,
    },

    email: {
        color: "#F9683D",
        textDecoration: "none",
    },

    footer: {
        textAlign: "center",
        marginTop: 20,
        color: "#9ca3af",
        fontSize: 12,
    },
};